<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("btn.qualityData.details") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/qualityData', query:{id: qualityPlanStatus.id}}">
              <span>{{$t('tlt.qualityData.write')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/qualityDataCheck', query:{id: qualityDataStatus.id}}">
              <span>{{$t('btn.qualityData.details')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div class="card">
        <div class="card-body">
          <form>
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.planCode')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.planCode"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.sampleCode')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.sampleCode"
                />
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.sampleName')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.sampleName"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.shift')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.shift"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.sentPerson')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.sentPerson"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.sentTime')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.sentTime"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.person')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.checkPerson"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.checkTime')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.receiveTime"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.itemName')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityDataStatus.itemName"
                />
              </div>
              <!-- <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityData.status')}}:</label>
                <select class="form-control" disabled="disabled" v-model="qualityDataStatus.status">
                  <option value="R">{{$t('lbl.qualityData.status.R')}}</option>
                  <option value="N">{{$t('lbl.qualityData.status.N')}}</option>
                  <option value="C">{{$t('lbl.qualityData.status.C')}}</option>
                </select>
              </div>-->
            </div>
          </form>
        </div>
      </div>
      <div id="qualityResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="qualityResult" inline-actions-disabled :singleChoice="true" disableEdit disableDelete :statusOrResult="[{qualityResult :'G',color: 'pink'},{qualityResult :'L',color: 'green'}]">
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <b-button
                    v-b-modal.modal-2
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength!=1"
                  >
                    <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                    <span class="text">{{$t('btn.qualityResult.check')}}</span>
                  </b-button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-2" title="样品检验" @ok="Check('qualityResult')">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col>{{$t('lbl.qualityResult.checkValue')}}</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <input class="form-control" type="text" v-model="checkValue" />
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import MmfTable from "@/components/MmfTable";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualityResult";


// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityResult/getField",
  mutationType: "qualityResult/updateField"
});

export default {
  name: "qualityDataList",
  data() {
    return {
    
    };
  },
  components: { MmfTable },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(fields),
    ...mapState({
      rows: state => state.qualityResult.rows,
      entity: state => state.qualityResult.entity,
      qualityDataStatus: state => state.qualityResult.qualityDataStatus,
      baseModuleUrl: state => state.qualityResult.baseModuleUrl,
      qualityPlanStatus: state => state.qualityData.qualityPlanStatus
    })
  },
  methods: {
    ...mapActions("qualityResult", ["Check"]),

    
  },
  created() {
    const context = this.$store;
    const id = this.$route.query.id; // 从当前的路由中获取参数 id
    const baseModuleUrl = this.baseModuleUrl;

    context
      .dispatch("api/get", {
        url: baseModuleUrl + "/qualityData/findById/" + id
      })
      .then(response => {
        context.commit("qualityResult" + "/setRows", response.qualityResults);
        context.dispatch("qualityResult/qualityDataStatus", response, {
          root: true
        });
      });

    context
      .dispatch("api/get", {
        url: baseModuleUrl + "/qualityData/findQualityPlanById/" + id
      })
      .then(response => {
        context.dispatch("qualityData/qualityPlanStatus", response, {
          root: true
        });
      });
    this.clear();
  }
};
</script>
